<template>
  <div>
    <div
      class="loading flex justify-center"
      style="min-height: 7rem; margin-top: 2rem"
    >
      <span class="size bg-color-23"></span>
      <span class="size bg-color-23"></span>
      <span class="size bg-color-23"></span>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  created() {
    console.log(this.$route.params);
    var token = common.getCookie("utoken") || '';
    console.log('--------', token);
    if (token == "") {
      if (this.$route.query.first == "false") {
        var http =
          common.httpcompany +
          this.$route.query.gid +
          "&productId=3&redirectUrl=" +
          encodeURI(common.http + "AutoLogin/login?first=true&gid=0");
        window.open(http, "_self");
      } else {
        var httpurl = localStorage.getItem("islogin_httpurl") || "";
        if (httpurl == "") {
          httpurl = common.http;
        }
        window.location.replace(httpurl);
      }
    } else {
      var httpurl = localStorage.getItem("islogin_httpurl") || "";
      if (httpurl == "") {
        httpurl = common.http;
      }
      window.location.replace(httpurl);
    }
  },
  methods: {
     getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/autoLogin/login.vue